import React, { Component } from 'react'
import TableHead from '@material-ui/core/TableHead';
import StyleSheet from '../../styles'
import PropTypes from 'prop-types'
import {IndexContext} from '..'

export class SortedTableHead extends Component{

  static propTypes = {
    onOrderChange: PropTypes.func.isRequired,
    order: PropTypes.object,
  }

  get orderBy() {
    const {order} = this.props
    return order && order.startsWith('-') ? order.substr(1) : order
  }

  get desc() {
    const {order} = this.props
    return !!order && order.startsWith('-')
  }

  handleOrderChange = orderBy => () => {
    this.props.onOrderChange((this.orderBy !== orderBy || this.desc) ? orderBy : `-${orderBy}`)
  }

  renderSortableCell = ({props: { orderBy, ...props}, type: Cell}, idx) => {
    if(orderBy !== undefined){
      if(this.orderBy === orderBy){
        props.children += this.desc ? ' ▲' : ' ▼'
      }
      props.className = (props.className || '') + ` ${styles.clickableHeaderCell}`
      props.onClick = this.handleOrderChange(orderBy)
    }
    return <Cell key={idx} {...props}/>
  }

  renderChildren = () =>{
    const {type: Row, props: { children,...rowProps}} = this.props.children
    return (
      <Row {...rowProps}>
        {children.filter(c => c).map(this.renderSortableCell)}
      </Row>
    )
  }

  render = () =>
    <TableHead className={this.props.className}>
      {this.renderChildren()}
    </TableHead>

}


const styles = StyleSheet({
  clickableHeaderCell: {
    cursor: 'pointer',
    '-webkit-touch-callout': 'none',
      '-webkit-user-select': 'none',
       '-khtml-user-select': 'none',
         '-moz-user-select': 'none',
          '-ms-user-select': 'none',
              'user-select': 'none'
  }
})

export default class SortedTableHeadWrapper extends Component {
  render = () =>
    <IndexContext.Consumer>{value => <SortedTableHead {...value} {...this.props} />}</IndexContext.Consumer>
}